import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { SlingoConstants } from "../enum/SlingoConstants";
import { CompleteReason } from "./CompleteReason";
/*
 * GameProgressData.ts
 */
export class GameProgressData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.standardSpins = this.data.getNumber(SlingoConstants.PROPERTY_STANDARD_SPINS);
            this.totalSpins = this.data.getNumber(SlingoConstants.PROPERTY_TOTAL_SPINS);
            this.spinsRemaining = this.data.getNumber(SlingoConstants.PROPERTY_SPINS_REMAINING);
            this.freeSpinsRemaining = this.data.getNumber(SlingoConstants.PROPERTY_FREE_SPINS_REMAINING);
            this.freeSpinsAwarded = this.data.getNumber(SlingoConstants.PROPERTY_FREE_SPINS);
            this.symbolWin = this.data.getNumber(SlingoConstants.PROPERTY_SYMBOL_WIN);
            this.patternWin = this.data.getNumber(SlingoConstants.PROPERTY_PATTERN_WIN);
            this.matchedPatterns = this.data.getNumber(SlingoConstants.PROPERTY_MATCHED_PATTERNS);
            this.purchasableSpinsRemaining = this.data.getNumber(SlingoConstants.PROPERTY_PURCHASABLE_SPINS_REMAINING);
            this.purchasableSpinsAvailable = this.data.getNumber(SlingoConstants.PROPERTY_PURCHASABLE_SPINS_AVAILABLE);
            this.purchaseSpinTotalStaked = this.data.getNumber(SlingoConstants.PURCHASE_SPIN_TOTAL_STAKED);
            this.totalStaked = this.data.getNumber(SlingoConstants.PROPERTY_TOTAL_STAKED);
            this.standardStake = this.data.getNumber(SlingoConstants.PROPERTY_STANDARD_STAKE);
            this.currentSpinPrice = this.data.getNumber(SlingoConstants.CURRENT_SPIN_PRICE);
            this.nextSpinPrice = this.data.getNumber(SlingoConstants.NEXT_SPIN_PRICE);
            this.matchedNumbers = this.data.getNumberArray(SlingoConstants.PROPERTY_MATCHED_NUMBERS);
            this.isFirstPurchaseSpin = this.data.getBool(SlingoConstants.PROPERTY_IS_FIRST_PURCHASE_SPIN);
            this.purchaseSpinsUsed = this.data.getNumber(SlingoConstants.PROPERTY_PURCHASE_SPINS_USED);
            this.completeReason = CompleteReason.getReason(this.data.getString(SlingoConstants.PROPERTY_COMPLETE_REASON));
            this.nextStakeToSpin = this.data.getNumber(SlingoConstants.PROPERTY_NEXT_STAKE_TO_SPIN);
            this.nextStakeToSpinChance = this.data.getNumber(SlingoConstants.PROPERTY_NEXT_STAKE_TO_SPIN_CHANCE);
            this.stakeToSpin = this.data.getNumber(SlingoConstants.PROPERTY_STAKE_TO_SPIN);
        }
    }
    getStandardSpins() {
        return this.standardSpins;
    }
    getTotalSpins() {
        return this.totalSpins;
    }
    getSpinsRemaining() {
        return this.spinsRemaining;
    }
    getFreeSpinsAwarded() {
        return this.freeSpinsAwarded;
    }
    getFreeSpinsRemaining() {
        return this.freeSpinsRemaining;
    }
    getPurchasableSpinsRemaining() {
        return this.purchasableSpinsRemaining;
    }
    getPurchasableSpinsAvailable() {
        return this.purchasableSpinsAvailable;
    }
    getSymbolWin() {
        return this.symbolWin;
    }
    getCurrentSpinPrice() {
        return this.currentSpinPrice;
    }
    getNextSpinPrice() {
        return this.nextSpinPrice;
    }
    getPatternWin() {
        return this.patternWin;
    }
    getMatchedPatterns() {
        return this.matchedPatterns;
    }
    getMatchedNumbers() {
        return this.matchedNumbers?.slice();
    }
    isFirstFreeSpin() {
        return this.freeSpinsAwarded == this.freeSpinsRemaining;
    }
    isFirstPurchasableSpin() {
        if (this.isFirstPurchaseSpin != undefined) {
            Logger.debug("First purchase spin received from server");
            return this.isFirstPurchaseSpin;
        }
        else {
            return this.purchasableSpinsRemaining + this.freeSpinsAwarded == this.purchasableSpinsAvailable;
        }
    }
    getPurchaseSpinTotalStaked() {
        return this.purchaseSpinTotalStaked;
    }
    getTotalStaked() {
        return this.totalStaked;
    }
    getStandardStake() {
        return this.standardStake;
    }
    getPurchaseSpinsUsed() {
        return this.purchaseSpinsUsed;
    }
    getCompleteReason() {
        return this.completeReason;
    }
    getNextStakeToSpin() {
        return this.nextStakeToSpin;
    }
    getNextStakeToSpinChance() {
        return this.nextStakeToSpinChance;
    }
    getStakeToSpin() {
        return this.stakeToSpin;
    }
}
//# sourceMappingURL=GameProgressData.js.map